import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const getContractAPI = async ({subsidiaryId, file}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const search = file ? `?file=${encodeURIComponent(file)}` : "";
    const URL = `${BASE_URL}/${requestSubsidiaryId}/public/customer/contract${search}`;
    const METHOD = "GET";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    return await response.json();
};

export {getContractAPI};
